<div class="middle-box text-center loginscreen animated fadeInDown">
  <div>
      <div class="mt-5">

          <h1 class="logo-name"><img src="/assets/images/fire-foresight.png"></h1>

      </div>
      <h3 class="mt-5 mb-5 h3">Onboarding Fire Foresight Customer</h3>
      <div *ngIf="azureAuthService.isLoggedIn" class="mt-5">
        <p>You are already authenticated, you can complete the onboarding process by clicking the button below</p>
        <form class="m-t">
          <button (click)="completeActivation()" type="submit" class="btn btn-white block full-width m-b">Complete Activation</button>
        </form>
      </div>
      <p class="m-t mt-5"> <small>Indicium Dynamics Pty Ltd. Copyright 2022</small> </p>
  </div>
</div>